import {
  collectTargetIds,
  mergeTableHtmlReferencesIntoEntries,
} from '../../../../utils/word/attach-table-html-references'
import { buildWorkingDocSectionEntries } from '../../../../utils/word/build-working-doc-section-entries'
import {
  buildTableReferences,
  getDocumentHierarchicalStructure,
  getDocumentParagraphs,
  getDocumentText,
  getFullDocumentComments,
  getSelectedParagraphs,
  resolveSectionTypeFromId,
} from '../../../word/word-service'
import type { SkillRunResult } from '../../types'
import { parseGetSectionArgs } from './utils'

export async function runGetDocumentOutline(): Promise<SkillRunResult> {
  const tree = await getDocumentHierarchicalStructure()
  return { ok: true, content: tree }
}

export async function runGetCurrentDocument(): Promise<SkillRunResult> {
  const text = await getDocumentText()
  return { ok: true, content: text }
}

export async function runGetSection(args: Record<string, unknown>): Promise<SkillRunResult> {
  const parsedArgs = parseGetSectionArgs(args)
  if (!parsedArgs.ok) {
    return { ok: false, error: parsedArgs.error }
  }

  // if useHtml is omitted, it defaults to true
  // if perParagraph is omitted, it defaults to false
  const { id, useHtml, perParagraph } = parsedArgs

  const type = await resolveSectionTypeFromId(id)
  if (type === null) {
    return { ok: false, error: `Section id "${id}" not found in document.` }
  }

  const sectionEntries = await buildWorkingDocSectionEntries(
    { id, type },
    { perParagraph, useHtml }
  )

  if (sectionEntries.length === 0) {
    return { ok: false, error: `Section id "${id}" not found in document.` }
  }

  if (!perParagraph) {
    return { ok: true, content: sectionEntries }
  }

  const tableReferenceResult = await buildTableReferences(collectTargetIds(sectionEntries))
  const { contextEntries } = mergeTableHtmlReferencesIntoEntries(
    sectionEntries,
    tableReferenceResult
  )
  return { ok: true, content: contextEntries }
}

export async function runGetSelectedParagraphs(): Promise<SkillRunResult> {
  const paragraphs = await getSelectedParagraphs()
  return { ok: true, content: paragraphs }
}

export async function runGetDocumentParagraphs(): Promise<SkillRunResult> {
  const paragraphs = await getDocumentParagraphs()
  return { ok: true, content: paragraphs }
}

export async function runGetFullDocumentComments(): Promise<SkillRunResult> {
  const comments = await getFullDocumentComments()
  return { ok: true, content: comments }
}
